import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function GlobalSearch() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [res, setRes] = useState(null);
  useEffect(() => { if (q) api.get("/search", { params: { q } }).then(r => setRes(r.data)); }, [q]);
  if (!res) return <div className="text-zinc-500 text-sm">Searching…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Global Search</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Results for &ldquo;{q}&rdquo;</h1>
      </div>
      {[["Assets","assets",(x)=>`/assets/${x.id}`,(x)=>x.hostname],["Tickets","tickets",(x)=>`/tickets/${x.id}`,(x)=>x.title],["Clients","clients",(x)=>`/clients/${x.id}`,(x)=>x.name],["Documents","documents",(x)=>`/docs`,(x)=>x.title]].map(([label,k,linker,labelFn]) => (
        <div key={k} className="bg-zinc-950 border border-zinc-900 rounded-md p-4">
          <div className="font-display font-medium mb-2">{label} ({res[k]?.length || 0})</div>
          <div className="space-y-1">
            {(res[k] || []).map(x => <Link key={x.id} to={linker(x)} className="block text-sm text-zinc-300 hover:text-blue-400 font-mono">{labelFn(x)}</Link>)}
            {(res[k] || []).length === 0 && <div className="text-zinc-500 text-sm">No matches.</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
